import { render } from "./ListeDemandePrixPage.vue?vue&type=template&id=5bf40fbb&ts=true"
import script from "./ListeDemandePrixPage.vue?vue&type=script&lang=ts"
export * from "./ListeDemandePrixPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__